// import { useMemo } from "react";

// const useNumberFormat = () => {
//     const locale = navigator.language || "en-US";

//     return (value, fractionDigits = 2) => {
//         const formatter = new Intl.NumberFormat(locale, {
//             minimumFractionDigits: fractionDigits,
//             maximumFractionDigits: fractionDigits,
//         });

//         return formatter.format(value);
//     };
// };

// export default useNumberFormat;

import { useMemo } from "react";

const useNumberFormat = () => {
    const locale = navigator.language || "en-US";

    return (value, fractionDigits = 2) => {
        const formatter = new Intl.NumberFormat(locale, {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        });

        return formatter.format(isNaN(value) ? 0 : value);
    };
};

export default useNumberFormat;
